module.exports = __webpack_public_path__ + "static/media/daura.68d6178d.jpg";